export type FooterLink = {
  label: string;
  href: string;
};

export const productFooterLinks: FooterLink[] = [
  { label: 'Funkciók', href: '/#funkciok' },
  { label: 'Hogyan működik', href: '/#hogyan' },
  { label: 'Megbízhatóság', href: '/#megbizhatosag' },
  { label: 'Béta várólista', href: '/#beta' },
  { label: 'Kapcsolat', href: '/kapcsolat/' }
];

export const legalFooterLinks: FooterLink[] = [
  { label: 'Adatvédelem', href: '/adatvedelem/' },
  { label: 'ÁSZF', href: '/aszf/' },
  { label: 'Süti szabályzat', href: '/sutik/' },
  { label: 'Elállás a szerződéstől', href: '/elallas/' }
];
